<template>
    <AppHead :title="episode.title" />

    <div class="flex flex-col items-center md:-mt-24 md:pt-24 pt-8 pb-16 md:pb-0">
        <div class="flex flex-1 flex-col w-full space-y-4 pt-6 pb-10 md:pt-0 md:space-y-10">
            <!-- Cover -->
            <div class="w-full flex-1 flex flex-col items-center justify-center">
                <div class="w-[60vw] h-[60vw] md:w-72 md:h-72 lg:w-[20vw] lg:h-[20vw] bg-cover bg-center rounded-xl lg:rounded-3xl" :style="'background-image: url(' + image + ')'">
                </div>
            </div>


            <!-- Title -->
            <div class="flex flex-col w-full items-start md:items-center px-4 pt-4 bg-gray-300 pb-3 md:pb-0">
                <div class="font-semibold text-2xl md:text-4xl xl:text-5xl line-clamp-2 leading-tight mb-1.5 md:pb-2">
                    {{ episode.title }}
                </div>
                <div v-for="user in episode.users" class="flex space-x-2.5 items-center">
                    <div class="w-12 h-12 flex items-center justify-center rounded-full bg-gray-300 bg-center bg-cover border border-gray-400" :style="'background-image: url(' + user.avatar + ')'">
                        <div class="font-medium text-gray-700 text-sm" v-if="!user.avatar">
                            {{ user.name.charAt(0) }}
                        </div>
                    </div>

                    <div class="text-sm">
                        <div class="font-medium leading-tight">
                            {{ user.name }}
                        </div>
                        <div class="">
                            {{ episode.published }}
                        </div>
                        <!-- <div v-if="played">
                            ·
                        </div>
                        <div v-if="played" class="flex items-center space-x-0.5 text-regal-blue-700">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
                            <div class="">
                                Played
                            </div>
                        </div> -->
                    </div>
                    <div @click="showDescription = true" v-if="episode.description" class="text-sm font-medium px-3 py-1.5 rounded-full border border-gray-400 hover:bg-white cursor-pointer text-gray-800 flex items-center space-x-1.5">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                        <div>Show notes</div>
                    </div>
                </div>
            </div>

            <div class="w-full px-4">
                <AudioPlayer v-if="'ogg' in episode.audio" :episode="episode" @ping="handleProgress"/>
                <HlsPlayer v-if="'manifest' in episode.audio" :episode="episode" @ping="handleProgress"/>
            </div>
        </div>

        <Modal v-model:open="showDescription">
            <div class="max-w-prose w-full">
                <div class="font-semibold text-lg">Episode description</div>
                <div class="mt-4 text-sm">{{ episode.description }}</div>
            </div>
        </Modal>


    </div>
</template>

<script>
    import Layout from '@/Shared/Layout'
    import AudioPlayer from '@/Shared/AudioPlayer'
    import HlsPlayer from '@/Shared/HlsPlayer'
    import { ref } from 'vue'
    import axios from 'axios'
    import Modal from '@/Shared/Modal'

    export default {
        setup(props) {
            const remaining = ref(props.episode.formattedRemaining)
            const played = ref(props.episode.played)
            const showDescription = ref(false)

            return { remaining, played, showDescription }
        },
        methods: {
            handleProgress(secArray) {
                axios.patch(route('episodes.track.playback', this.episode.uuid), {
                    ticks: secArray
                }).then(res => {
                    this.remaining = res.data.remaining
                    this.played = res.data.played
                })
            }
        },
        props: {
            episode: Object,
            image: String,
        },
        layout: (h, page) => h(Layout, () => page),
        components: { AudioPlayer, HlsPlayer, Modal },
    }
</script>
